import _regeneratorRuntime from "/codebuild/output/src1688139503/src/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/codebuild/output/src1688139503/src/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/codebuild/output/src1688139503/src/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
var __default__ = {
  name: "ForumSwitch",
  computed: _objectSpread({}, mapState(["school"]))
};
import { ref } from "vue";
import { getData } from "@/services/axios";
import { mapState } from "vuex"; // import RowItem from "@/components/RowItem.vue";

import ForumArticle from "@/components/forums/ForumArticle.vue";
import { storeToRefs } from "pinia";
import { useSchoolPlanStore } from "@/stores/schoolPlan";
export default /*#__PURE__*/Object.assign(__default__, {
  setup: function setup(__props) {
    // @ts-check
    var _storeToRefs = storeToRefs(useSchoolPlanStore()),
        schoolPlan = _storeToRefs.schoolPlan;

    var forumList = ref([]);

    var setData = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return getData("school_forums?from=2023-04-01&to=2024-03-31");

              case 3:
                data = _context.sent;
                forumList.value = data.items;
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                console.log(_context.t0);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 7]]);
      }));

      return function setData() {
        return _ref.apply(this, arguments);
      };
    }();

    setData();
    return {
      __sfc: true,
      schoolPlan: schoolPlan,
      forumList: forumList,
      setData: setData,
      ForumArticle: ForumArticle
    };
  }
});